import { IMessageParts, IMessageBody } from "../interfaces";



export function formatPlainTextToParts(messageBody: IMessageBody): IMessageParts[]{
       
        const plaintextDelimter = '[plaintextDelimter]'

        const parts = messageBody.plainText
            //add nonsense delimiter character around special characters
            .replaceAll('\n', `${plaintextDelimter}\n${plaintextDelimter}`)
            //remove double occurences when two special characters are next to each other
            .replaceAll(`${plaintextDelimter}${plaintextDelimter}`, plaintextDelimter)
            //split on delimter for parsing int parts
            .split(plaintextDelimter);
        return parts.map((p:string) => {
            if(p === '\n') {
                return {
                    type: 'linebreak'
                }
            }
            else {
                return {
                    type:'plaintext',
                    text: p
                }
            }
        })
    }